import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBodyExtraSmall from './FsBodyExtraSmall';

const FsBodyExtraSmallBold = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 600,
    },
  })
)((props: TypographyAllProps) => <FsBodyExtraSmall {...props} />);

export default FsBodyExtraSmallBold;
